module.exports = __webpack_public_path__ + "28d649c84837b836a9b1cefaa5408d72.svg";